import L from 'leaflet';
import 'leaflet.markercluster';
import { createClusterIcon } from './mapMarkers';

/**
 * Creates a marker cluster group in the shared CartLens style (see
 * src/lib/mapMarkers.ts), falling back to a plain FeatureGroup if the
 * leaflet.markercluster plugin isn't attached to this Leaflet instance. The
 * plugin registers itself on the global `window.L`; when two Leaflet copies
 * end up in one page (e.g. Vite re-optimizing deps mid-session) it can attach
 * to the other copy, and `markerClusterGroup()` throws "L.MarkerClusterGroup
 * is not a constructor" — which used to take down the whole dashboard.
 */
export const createMarkerClusterGroup = (options: Record<string, unknown> = {}): L.FeatureGroup => {
  try {
    const factory = (L as any).markerClusterGroup ?? (window as any).L?.markerClusterGroup;
    if (typeof factory === 'function') {
      return factory({
        showCoverageOnHover: false,
        maxClusterRadius: 40,
        iconCreateFunction: (cluster: any) => createClusterIcon(cluster.getChildCount()),
        ...options,
      });
    }
  } catch (err) {
    console.warn('[Maps] Marker clustering unavailable, showing unclustered markers:', err);
  }
  return L.featureGroup();
};
